<template>
  <div v-show="enableChatAssistant && retainHoverButtonOnMobile" class="chat_assistant_bot">
    <div
      v-if="iconHeading"
      class="expand_btn"
      :class="chatAlignmentPosition()"
      :style="[{ bottom: mobileVerticalButtonPosition + 'px' }, themeBackground]"
    >
      <div class="assistance_box" @click="openAssistant()">
        <div>
          <assistant-icon
            :theme-settings="themeSettings"
            :width="40"
            :height="40"
            :auto-spin="true"
            :spin-duration="spinDuration"
          />
        </div>
      </div>
    </div>

    <div
      v-if="autoExpandAssistant"
      class="content"
      :class="{ 'animate-fade': autoExpandAssistant }"
      @mouseover="startHover"
      @mouseleave="endHover"
      @click.prevent="openChat()"
    >
      <div class="py-c-3 position-relative">
        <div class="assistant_close_icon" @click.stop="closeAssistant()">
          <em class="primaryicon-times" />
        </div>
        <div class="d-flex align-items-center justify-content-center assistant_header">
          <assistant-icon :width="35" :height="35" />
          <h6 class="font-weight-bold _theme_font_bold m-0 ml-2">{{ enlargedIconHeading }}</h6>
        </div>
      </div>
      <div
        class="services_options_container br-15 py-3 overflow-hidden px-3"
        :style="{
          background: assistantSettingsData?.enlargedLaunchBackgroundColor
            ? assistantSettingsData.enlargedLaunchBackgroundColor
            : primaryColor,
        }"
      >
        <div>
          <div class="mb-3">
            <p :style="textWithOpacity">{{ enlargedIconSubHeading }}</p>
          </div>
          <div
            v-if="chipButtons && chipButtons.length"
            class="d-flex flex-wrap justify-content-left"
          >
            <button
              v-for="(item, index) in chipButtons"
              :key="index"
              :style="themeSettingsBackground"
              class="btn mb-2 mx-1 px-3 chips__btn"
              @click.stop="eachService(item)"
            >
              {{ item.flowName }}
            </button>
            <button
              v-if="enableTextAssistant"
              class="btn mb-2 mx-1 px-3 chips__btn"
              :style="themeSettingsBackground"
              @click.stop="eachService({ name: 'text' })"
            >
              {{ widgetLabel }}
            </button>
          </div>
          <div v-if="!isTilesAvailable" class="d-flex flex-wrap justify-content-center">
            <button
              v-if="enableTextAssistant"
              class="btn mb-2 mx-1 px-3 chips__btn"
              :style="themeSettingsBackground"
              @click.stop="eachService({ name: 'text' })"
            >
              {{ widgetLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AssistantIcon from "../ChatAssistant/AssistantIcon.vue";
import axios from "axios";
import { ChatWidgetService } from "../../../Services/ChatWidgetService/ChatWidgetService";
import {
  getPageNameFromUrl,
  getPageWithAssistantCode,
  hexToRGBA,
} from "@/js/services/CommonUtility";

import { useChatSettingsStore } from "../../../store/ChatSettingsStore/ChatSettingsStore";
import {
  SET_CHAT_THEME_SETTINGS,
  SET_OPEN_TVM_HELP_MODAL,
  SET_OPEN_TVM_NAVIGATE_TILE,
} from "../../../../../store/StoreConstants/CommonSettingsConstants";
import { fireChatWidgetOpen } from "../../../Events/TagManagerServices/TaggingEventForPages";
import { mapWritableState } from "pinia";
import { useCommonSettingsStore } from "../../../store/CommonSettingsStore/CommonSettingsStore";
export default {
  components: {
    "assistant-icon": AssistantIcon,
  },
  data() {
    return {
      expandAssistant: false,
      primaryColor: window.primaryColor,
      isAnimatedIcon: false,
      isHover: false,
      intervalId: null,
      mouseLeaveIntervalId: null,
      autoExpandAssistant: false,
      INTERVAL: 6000,
      timerId: null,
      timer: 0,
      spinDuration: null,
      m_DurationToEnlargeLaunchIcon: null,
      m_EnlargedLaunchIconStayDuration: null,
      iconHeading: "",
      enlargedIconHeading: "",
      enlargedIconSubHeading: "",
      chipButtons: [],
      widgetPosition: "",
      enableTextAssistant: false,
      widgetLabel: "",
      isAssistantOpened: false,
      paramValue: {},
      enableChatAssistant: false,
      retainHoverButtonOnMobile: false,
      mobileVerticalButtonPosition: 120,
      themeSettings: {
        backgroundColor: "",
        textColor: "",
        iconColor: "",
      },
      assistantSettingsData: null,
    };
  },
  computed: {
    themeBackground() {
      return {
        background: this.themeSettings?.backgroundColor
          ? this.themeSettings?.backgroundColor
          : "#fff",
      };
    },
    themeTextColor() {
      return {
        color: this.themeSettings?.textColor ? this.themeSettings?.textColor : "#000",
      };
    },
    textWithOpacity() {
      return {
        color: this.assistantSettingsData?.enlargedLaunchSubHeadingFontColor
          ? this.assistantSettingsData?.enlargedLaunchSubHeadingFontColor
          : "#ffffffcc",
      };
    },
    themeSettingsBackground() {
      return {
        background: this.assistantSettingsData?.enlargedLaunchCTAColor
          ? this.assistantSettingsData?.enlargedLaunchCTAColor
          : "rgba(255, 255, 255, 0.1)",
        color: this.assistantSettingsData?.enlargedLaunchCTAFontColor
          ? this.assistantSettingsData?.enlargedLaunchCTAFontColor
          : "#ffffffcc",
      };
    },
    ...mapWritableState(useCommonSettingsStore, [
      "tvmNavigateTileSettings",
      "tvmHelpModalSettings",
    ]),
  },
  watch: {
    isHover(val) {
      if (val) {
        clearInterval(this.intervalId);
        clearInterval(this.mouseLeaveIntervalId);
      } else {
        let timeDiff = this.m_EnlargedLaunchIconStayDuration - this.timer * 1000;
        this.mouseLeaveCloseAssistant(this.m_EnlargedLaunchIconStayDuration - timeDiff);
      }
    },
    timer(newTime) {
      if (newTime === -1) {
        this.start();
      }
    },
    autoExpandAssistant(val) {
      if (val) {
        this.mouseLeaveCloseAssistant(this.m_EnlargedLaunchIconStayDuration);
      }
    },
    isAssistantOpened(val) {
      if (val) {
        clearInterval(this.intervalId);
      }
    },
  },
  // beforeDestroy() {
  //   window.removeEventListener('backbutton', this.mobileBackButtonToMinimizeAssistant);
  // },
  mounted() {
    this.getAssistantSettings();
    setTimeout(() => {
      this.isCheckModalOpen();
    }, 1000);
    if (
      window.performance &&
      window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD
    ) {
      this.mobileBackButtonToMinimizeAssistant();
    }
    window.addEventListener("assistantOpenWithCTA", this.assistantOpenWithCTAOpen);
  },

  methods: {
    openAssistant() {
      this.$emit("openchat");
      this.isAssistantOpened = true;
      fireChatWidgetOpen();
      window.dispatchEvent(new CustomEvent("tvmLoadPopUp", { detail: true }));
    },
    assistantAutoOpen(val) {
      let count = 0;
      this.intervalId = setInterval(() => {
        count++;
        this.autoExpandAssistant = !this.autoExpandAssistant;
        ChatWidgetService.setAssistantButtonSession();
        if (count === 1) {
          clearInterval(this.intervalId);
        }
      }, val);
    },
    startHover() {
      this.isHover = true;
      this.pause();
    },
    endHover() {
      this.isHover = false;
      this.start();
    },
    openChat() {
      this.$emit("openchat");
      this.autoExpandAssistant = false;
    },
    closeAssistant() {
      this.$emit("openAssistant", true);
      this.autoExpandAssistant = false;
    },
    mouseLeaveCloseAssistant(val) {
      let count = 0;
      this.mouseLeaveIntervalId = setInterval(() => {
        count++;
        this.autoExpandAssistant = !this.autoExpandAssistant;
        if (count === 1) {
          clearInterval(this.mouseLeaveIntervalId);
        }
      }, val);
    },
    eachService(val) {
      this.$emit("openchat", val);
      sessionStorage.setItem("openchat", JSON.stringify(val));
      setTimeout(() => {
        this.autoExpandAssistant = false;
      }, 500);
    },
    start() {
      clearInterval(this.timerId);
      this.timer = this.timer > 0 ? this.timer : this.m_EnlargedLaunchIconStayDuration / 1000;
      this.timerId = setInterval(() => {
        this.timer -= 1;
      }, 1000);
    },
    pause() {
      clearInterval(this.timerId);
    },
    getAssistantSettings() {
      let searchParamsData = new URLSearchParams(location.search);
      this.paramValue.assistant = searchParamsData.get("assistant");
      this.paramValue.utm_medium = searchParamsData.get("utm_medium") || "";
      this.paramValue.vin = searchParamsData.get("vin") || "";
      let url = `${window.chatWidgetApiBaseUrl}/ChatBot/assistantsettings/${window.accountId}/${window.campaignId}`;
      if (window.userDetails?.consumerid) {
        let consumerId = window.userDetails?.consumerid;
        url = url + `?consumerId=${consumerId}`;
      }
      axios
        .get(url)
        .then((response) => {
          if (response && response.data) {
            let res = response.data;
            this.assistantSettingsData = res;
            this.enableChatAssistant = res.enableChatAssistant;
            this.retainHoverButtonOnMobile = res.retainHoverButtonOnMobile;
            this.spinDuration = res.m_LaunchIconAnimation * 1000 || 0;
            this.m_DurationToEnlargeLaunchIcon = res.m_DurationToEnlargeLaunchIcon * 1000 || 6000;
            this.m_EnlargedLaunchIconStayDuration =
              res.m_EnlargedLaunchIconStayDuration * 1000 || 6000;
            this.iconHeading = res.iconHeading || "Need Assistance?";
            this.enlargedIconHeading = res.enlargedIconHeading || "Save Time With Your Assistant";
            this.enlargedIconSubHeading =
              res.enlargedIconSubHeading || "I can Quickly guide you through the following:";
            this.widgetPosition = res.widgetPosition || "bottom right";
            this.enableTextAssistant = res.enableTextAssistant;
            this.widgetLabel = res.widgetLabel || "Text Us";
            sessionStorage.setItem("tilesAvailable", res.tilesAvailable);
            this.isTilesAvailable = res.tilesAvailable;
            this.mobileVerticalButtonPosition = res.mobileVerticalButtonPosition || 120;
            this.themeSettings.backgroundColor = res.launchIconBackgroundColor;
            this.themeSettings.textColor = res.launchIconTextColor;
            this.themeSettings.iconColor = res.launchIconColor;

            let chatThemeSettings = {};
            if (res.launchIconColorForAssistant && res.launchIconColor) {
              chatThemeSettings.primeColor = res.launchIconColor;
              chatThemeSettings.borderColor = hexToRGBA(
                res.launchIconColor,
                res.themeOpacity || 60
              );
              chatThemeSettings.launchIconColorForAssistant = true;
              chatThemeSettings.backgroundColor = res.launchIconBackgroundColor;
              chatThemeSettings.textColor = res.launchIconTextColor;
              chatThemeSettings.iconColor = res.launchIconColor;
              const storeThemeSettings = useChatSettingsStore();
              storeThemeSettings.chatThemeSettings = chatThemeSettings;

              // store.commit(SET_CHAT_THEME_SETTINGS, chatThemeSettings);
            }
            if (res.oemThemeColorForAssistant) {
              chatThemeSettings.primeColor = window.primaryColor;
              chatThemeSettings.borderColor = hexToRGBA(
                window.primaryColor,
                res.themeOpacity || 60
              );
              chatThemeSettings.oemThemeColorForAssistant = true;
              chatThemeSettings.backgroundColor = res.launchIconBackgroundColor;
              chatThemeSettings.textColor = res.launchIconTextColor;
              chatThemeSettings.iconColor = res.launchIconColor;
              const storeThemeSettings = useChatSettingsStore();
              storeThemeSettings.chatThemeSettings = chatThemeSettings;
              // store.commit(SET_CHAT_THEME_SETTINGS, chatThemeSettings);
            }

            if (res.flows && res.flows.length && this.enableChatAssistant) {
              res.flows.forEach((item) => {
                if (item.enableOnEnlargedLaunchIcon) {
                  this.chipButtons.push(item);
                }
              });
              this.checkAndLaunchAssistant(res);
              window.assistantSettings = res;
            }
            let isChatOpened = false;
            if (sessionStorage.getItem("isAssistantButtonSession") !== null) {
              isChatOpened = sessionStorage.getItem("isAssistantButtonSession");
            }
            if (!isChatOpened && !res.m_DisableEnlargedLaunchIcon && !this.paramValue?.assistant) {
              this.assistantAutoOpen(this.m_DurationToEnlargeLaunchIcon);
              this.start();
            }
            if (this.enableChatAssistant) {
              this.navigateWebBannerToAssistant(res);
            }
          } else {
            this.spinDuration = 3000;
            this.iconHeading = "Need Assistance?";
            this.enlargedIconHeading = "Save Time With Your Assistant";
            this.enlargedIconSubHeading = "I can Quickly guide you through the following:";
            this.widgetPosition = "bottom right";
            this.widgetLabel = "Text Us";
            this.mobileVerticalButtonPosition = 120;
            this.assistantAutoOpen(6000);
            this.start();
          }
        })
        .catch((error) => {
          this.spinDuration = 3000;
          this.iconHeading = "Need Assistance?";
          this.enlargedIconHeading = "Save Time With Your Assistant";
          this.enlargedIconSubHeading = "I can Quickly guide you through the following:";
          this.widgetPosition = "bottom right";
          this.widgetLabel = "Text Us";
          this.assistantAutoOpen(6000);
          this.start();
          console.log(error);
        });
    },
    chatAlignmentPosition() {
      return this.widgetPosition && this.widgetPosition.toLowerCase() === "bottom left"
        ? "position-left-alignment"
        : "position-right-alignment";
    },
    isCheckModalOpen() {
      let queryParams = new URLSearchParams(location.search).get("open");
      if (
        sessionStorage.getItem("chatTextModal") &&
        sessionStorage.getItem("chatTextModal") !== null
      ) {
        let chatTextModal = JSON.parse(sessionStorage.getItem("chatTextModal"));
        if (chatTextModal && queryParams !== "false") {
          this.$emit("openchat");
        }
      }
    },
    navigateWebBannerToAssistant(res) {
      let activeFlowIndicatorCode = sessionStorage.getItem("activeFlowIndicatorCode") || "";
      if (this.paramValue.assistant !== null) {
        if (this.paramValue.assistant.toLowerCase() === "mainmenu") {
          this.openChat();
        } else {
          this.openChat();
          if (this.paramValue.assistant && !this.paramValue.utm_medium) {
            ChatWidgetService.setAssistantButtonSession();
            let assistantCode = {};
            assistantCode.assistant = this.paramValue.assistant;
            assistantCode.utm_medium = this.paramValue?.utm_medium;
            assistantCode.vin = this.paramValue?.vin;
            assistantCode.ActivityTypes = "AutoWeb";
            if (res.consumer !== null && window.isauthenticated.toLowerCase() === "true") {
              assistantCode.consumer = res.consumer;
            }
            if (activeFlowIndicatorCode?.toUpperCase() !== assistantCode?.assistant.toUpperCase()) {
              this.tvmNavigateTileSettings = this.paramValue;
              // store.commit(SET_OPEN_TVM_NAVIGATE_TILE, this.paramValue);
            }
          }
        }
      }
    },
    checkAndLaunchAssistant(res) {
      let pageNames = getPageWithAssistantCode();
      let pageObj = {};
      let activeFlowIndicatorCode = sessionStorage.getItem("activeFlowIndicatorCode") || "";
      if (pageNames?.length && window.location.pathname) {
        pageObj = pageNames.find(
          (item) => item.pageName === getPageNameFromUrl(window.location.pathname)
        );
      }
      if (pageObj?.code) {
        let eachFlowSettings = res.flows.find((item) => item.code === pageObj?.code?.toUpperCase());
        if (
          this.paramValue?.utm_medium === "email" &&
          eachFlowSettings?.emailTargetEnabled &&
          eachFlowSettings?.isActive
        ) {
          this.openChat();
          let assistantCode = {};
          assistantCode.assistant = pageObj.code;
          assistantCode.utm_medium = this.paramValue?.utm_medium;
          assistantCode.vin = this.paramValue?.vin;
          assistantCode.ActivityTypes = "Email";
          if (res.consumer !== null && window.isauthenticated.toLowerCase() === "true") {
            assistantCode.consumer = res.consumer;
          }
          if (activeFlowIndicatorCode?.toUpperCase() !== pageObj?.code?.toUpperCase()) {
            this.tvmNavigateTileSettings = assistantCode;
            // store.commit(SET_OPEN_TVM_NAVIGATE_TILE, assistantCode);
          }
        } else if (eachFlowSettings?.websiteButtonEnabled && eachFlowSettings?.isActive) {
          this.openChat();
          let assistantCode = {};
          assistantCode.assistant = pageObj.code;
          assistantCode.vin = this.paramValue?.vin;
          assistantCode.ActivityTypes = "AutoWeb";
          if (res.consumer !== null && window.isauthenticated.toLowerCase() === "true") {
            assistantCode.consumer = res.consumer;
          }
          if (activeFlowIndicatorCode?.toUpperCase() !== pageObj?.code?.toUpperCase()) {
            this.tvmNavigateTileSettings = assistantCode;
            // store.commit(SET_OPEN_TVM_NAVIGATE_TILE, assistantCode);
          } else {
            sessionStorage.removeItem("hideTvmHelpModal");
          }
        } else {
          // No action needed for other cases.
        }
      }
    },
    checkEachModuleSession(assistantCode) {
      let getModalNavigateSession = JSON.parse(sessionStorage.getItem("modalNavigate"));
      if (
        assistantCode?.assistant !== getModalNavigateSession[assistantCode?.assistant]?.flowName
      ) {
        this.tvmHelpModalSettings = assistantCode;
        // store.commit(SET_OPEN_TVM_HELP_MODAL, assistantCode);
        let modalNavigateSession = {
          [assistantCode?.assistant]: {
            isModalPopupSession: true,
            flowName: assistantCode?.assistant,
          },
        };
        let savedData = Object.assign(modalNavigateSession, getModalNavigateSession);
        sessionStorage.setItem("modalNavigate", JSON.stringify(savedData));
      } else {
        this.tvmNavigateTileSettings = assistantCode;
        // store.commit(SET_OPEN_TVM_NAVIGATE_TILE, assistantCode);
      }
    },
    mobileBackButtonToMinimizeAssistant() {
      if (
        sessionStorage.getItem("chatTextModal") &&
        sessionStorage.getItem("chatTextModal") !== null
      ) {
        sessionStorage.removeItem("chatTextModal");
      }
    },
    assistantOpenWithCTAOpen(event) {
      this.openAssistant();
      this.tvmNavigateTileSettings = event.detail;
      // store.commit(SET_OPEN_TVM_NAVIGATE_TILE, event.detail);
    },
  },
};
</script>
<style lang="less" scoped>
.chat_assistant_bot {
  .expand_btn {
    width: 60px;
    height: 60px;
    background: #fff;
    transition: width 0.3s ease-in-out;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    border-radius: 15px;
    cursor: pointer;
    position: fixed;
    bottom: 120px;
    right: 10px;
    text-align: center;
    z-index: 99;

    .assistance_box {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        transform: rotate(-360deg);
        transition: transform 1s ease;
        height: 45px;

        &:hover {
          transform: rotate(360deg);
          transition: transform 1s ease;
        }
      }

      p {
        font-size: 12px;
        margin-bottom: 10px;
        letter-spacing: -0.5px;
        color: #000;
      }
    }

    &.position-left-alignment {
      left: 20px;
    }
  }

  .assistant_header img {
    transform: rotate(-360deg);
    transition: transform 1s ease;
    height: 45px;

    &:hover {
      transform: rotate(360deg);
      transition: transform 1s ease;
    }
  }

  .content {
    position: fixed;
    bottom: 10%;
    width: calc(100% - 20px);
    background: #fff;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    border-radius: 15px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    cursor: pointer;
    z-index: 999;

    h6 {
      margin: 0;
      white-space: nowrap;
      font-weight: bold;
      font-size: 1.1rem;
      color: #000;
      letter-spacing: -1px;
    }

    .chips__btn {
      background: rgba(255, 255, 255, 0.1);
      font-size: 13px;
      border-radius: 30px;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
        transition: 0.5s;
        box-shadow: none !important;
      }

      &:active {
        box-shadow: none;
        outline: none;
      }
    }
  }

  .br-15 {
    border-radius: 15px;
  }

  .text-white-opacity {
    color: #ffffffcc;
  }

  .animate-fade {
    animation: fadeIn 0.8s;
  }

  .assistant_close_icon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 12px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    em {
      transform: rotate(-360deg);
      transition: transform 1s ease;
      display: block;
      color: #0000005c;
      cursor: pointer;
      font-size: 12px !important;

      &:hover {
        transform: rotate(360deg);
        transition: transform 1s ease;
      }
    }
  }

  .animated_icon {
    animation: rotate 550ms ease;
  }

  .py-c-3 {
    padding: 1rem 0;
  }

  .services_options_container {
    p {
      font-size: 14px;
    }
  }

  @keyframes fadeIn {
    0% {
      transform: translateY(350px);
      opacity: 0;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(-360deg);
      transition: transform 550ms ease;
    }

    100% {
      transform: rotate(360deg);
      transition: transform 550ms ease;
    }
  }
}
</style>
